module Meevo.Components.Common {

  export const REMOVE_THIS_COOKIE_AND_DO_LOGOUT_KEY = 'REMOVE_THIS_COOKIE_AND_DO_LOGOUT';

  export class KioskModeLogic {
    static factory(): Function {
      const instance = (
        dataService: Meevo.Components.Common.ICommonDataService,
        identityService: Meevo.Components.Common.IIdentityService,
        $cookies: angular.cookies.ICookiesService
      ) => {
        return new KioskModeLogic(dataService, identityService, $cookies);
      };

      instance.$inject = [
        'meevo.components.common.DataService',
        'meevo.components.common.IdentityService',
        '$cookies',
      ];

      return instance;
    }


    protected lastIdentity: IIdentity;

    get locationQueryParams() {
      return `tenantId=${this.lastIdentity.tenantId}&locationId=${this.lastIdentity.locationId}`;
    }

    constructor(
      protected dataService: Meevo.Components.Common.ICommonDataService,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected $cookies: angular.cookies.ICookiesService
    ) {
      this.lastIdentity = angular.copy(this.identityService.current());
    }


    enableLogOutOnReload($rootScope: ng.IRootScopeService) {
      this.lastIdentity = angular.copy(this.identityService.current());
      this.$cookies.put(REMOVE_THIS_COOKIE_AND_DO_LOGOUT_KEY, '1');
      $rootScope.$broadcast(Meevo.Components.Common.Messages.KEEP_SESSION_ALIVE);
    }


    disableLogOutOnReload($rootScope: ng.IRootScopeService) {
      this.$cookies.remove(REMOVE_THIS_COOKIE_AND_DO_LOGOUT_KEY);
      this.lastIdentity = angular.copy(this.identityService.current());
      $rootScope.$broadcast(Meevo.Components.Common.Messages.RESTART_SESSION_COUNTDOWN);
    }

    checkCredentials(username: string, password: string): ng.IPromise<boolean> {
      return this.dataService.customMethodData('api/Auth/ValidateCredentials', 'POST', {
        userName: username,
        password
      }).then(({ data }) => data);
    }

    loginNewUser(username: string, password: string): ng.IPromise<void> {
      return this.dataService.login({
        username,
        password
      }).then(res => {
          if (res.bearerToken) {
              this.identityService.setToken(res.bearerToken);
          }
      });
    }

    isSameUser(userName: string): boolean {
      return this.lastIdentity.userName.toLowerCase() === userName.toLowerCase();
    }
  }

  angular.module('meevo.components.common')
    .service('meevo.components.common.KioskModeLogic', KioskModeLogic.factory());
}
